import client, { endpoints } from '../api/client';
import { ROLES } from '../constants/actionTypes';

const errMsg = (e) => e?.response?.data?.error || e?.message || 'Unknown error.';

export const fetchRoles = () => async (dispatch) => {
  dispatch({ type: ROLES.LIST_REQUEST });
  try {
    const { data } = await client.get(endpoints.roles.list);
    dispatch({ type: ROLES.LIST_SUCCESS, payload: data.items });
  } catch { /* ignore — list is fine empty */ }
};
export const fetchCapabilityCatalog = () => async (dispatch) => {
  try {
    const { data } = await client.get(endpoints.roles.capabilities);
    dispatch({ type: ROLES.CAPS_SUCCESS, payload: data.items });
  } catch {}
};
export const createRole = (payload) => async (dispatch) => {
  try {
    const { data } = await client.post(endpoints.roles.create, payload);
    dispatch({ type: ROLES.CREATE, payload: data.role });
    return { ok: true, role: data.role };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const updateRole = (id, patch) => async (dispatch) => {
  try {
    const { data } = await client.put(endpoints.roles.update(id), patch);
    dispatch({ type: ROLES.UPDATE, payload: data.role });
    return { ok: true };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const removeRole = (id) => async (dispatch) => {
  try { await client.delete(endpoints.roles.remove(id)); dispatch({ type: ROLES.REMOVE, payload: id }); return { ok: true }; }
  catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const ensureSystemRoles = () => async () => {
  try { const { data } = await client.post(endpoints.roles.ensureSystem); return { ok: true, ...data }; }
  catch (e) { return { ok: false, error: errMsg(e) }; }
};
